import { render, staticRenderFns } from "./CustomAttribute.vue?vue&type=template&id=15542030&scoped=true&"
import script from "./CustomAttribute.vue?vue&type=script&lang=js&"
export * from "./CustomAttribute.vue?vue&type=script&lang=js&"
import style0 from "./CustomAttribute.vue?vue&type=style&index=0&id=15542030&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15542030",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15542030')) {
      api.createRecord('15542030', component.options)
    } else {
      api.reload('15542030', component.options)
    }
    module.hot.accept("./CustomAttribute.vue?vue&type=template&id=15542030&scoped=true&", function () {
      api.rerender('15542030', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/attributes/CustomAttribute.vue"
export default component.exports